import { render, staticRenderFns } from "./editGift.vue?vue&type=template&id=036a15c2&scoped=true&"
import script from "./editGift.vue?vue&type=script&lang=js&"
export * from "./editGift.vue?vue&type=script&lang=js&"
import style0 from "./editGift.vue?vue&type=style&index=0&id=036a15c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a15c2",
  null
  
)

component.options.__file = "editGift.vue"
export default component.exports